// extracted by mini-css-extract-plugin
export default {"title":"AddressInformation_title__1tgHy","group":"AddressInformation_group__Wm6bo","field":"AddressInformation_field__mjuYZ"};